import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

// The BootstrapOptions used below were needed to fix a "change detection storm" caused by closing PrimeNG dialogs using the Escape key.
platformBrowserDynamic(providers).bootstrapModule(AppModule, {ngZoneEventCoalescing: true, ngZoneRunCoalescing: true})
  .catch(err => console.log(err));
